/* The separate Royal Pawtraits product keeps native Shopify variants and hosted portrait artwork authoritative. */
function initialiseRoyalProduct() {
  const section = document.querySelector('[data-royal-product]');
  if (!section || section.dataset.controllerReady) return;
  const $ = selector => section.querySelector(selector);
  const dialog = $('[data-royal-sheet]'), root = $('[data-uk-portrait]'), form = $('[data-royal-form]');
  const composer = root?.querySelector('.gemini-transformer'), master = form?.querySelector('select[name="id"]');
  const file = composer?.querySelector('input[type="file"]'), generate = composer?.querySelector('.gemini-transformer__button');
  const nativeAdd = $('[data-royal-native-add]'), cta = $('[data-royal-main-cta]');
  const image = $('[data-royal-sheet-art]'), stage = $('[data-royal-preview-stage]');
  const nameInput = $('[data-royal-sheet-name]'), status = $('[data-royal-order-status]');
  const customField = $('[data-royal-custom-field]'), customInput = $('[data-royal-custom-person]'), customPlaceholder = $('[data-royal-custom-placeholder]');
  let customError = $('[data-royal-custom-error]'), customTouched = false;
  if (customField && customInput && !customError) {
    customError = document.createElement('p'); customError.className = 'royal-sheet__status'; customError.setAttribute('data-royal-custom-error',''); customError.setAttribute('role','status');
    customError.id = 'RoyalCustomError-' + root.dataset.productId; customField.append(customError);
    customInput.setAttribute('aria-describedby',[customInput.getAttribute('aria-describedby'),customError.id].filter(Boolean).join(' '));
  }
  const sourceStatus = composer?.querySelector('.gemini-transformer__status');
  if (!dialog || !root || !form || !composer || !master || !file || !generate || !nativeAdd || !cta) return;
  let product;
  try { product = JSON.parse($('[data-royal-product-json]').textContent); } catch (_) { return; }
  const variants = product.variants.filter(variant => !/^canvas/i.test(variant.options[0]) || /^print only\s*-\s*no frame$/i.test(variant.options[1] || '')), frames = ['black','white','natural'];
  const canvas = variant => /^canvas/i.test(variant.options[0]);
  const finishOf = variant => canvas(variant) ? 'canvas' : /black/i.test(variant.options[1]) ? 'black' : /white/i.test(variant.options[1]) ? 'white' : /natural|wood/i.test(variant.options[1]) && !/no frame/i.test(variant.options[1]) ? 'natural' : 'none';
  const sizeOf = variant => canvas(variant) && /30\s*[x×]\s*40\s*cm/i.test(variant.options[0]) ? '30X40' : (variant.options[0].match(/A[234]/i) || [variant.options[0]])[0].toUpperCase();
  const familyOf = finish => frames.includes(finish) ? 'framed' : finish;
  const names = {none:'Print',canvas:'Canvas',black:'Black frame',white:'White frame',natural:'Natural wood'};
  const sizes = {A4:'Small',A3:'Medium',A2:'Large','30X40':'Large'};
  const dimensions = {A4:'21 × 29.7 cm',A3:'29.7 × 42 cm',A2:'42 × 59.4 cm','30X40':'30 × 40 cm'};
  const money = variant => variant?.money.replace(/<[^>]*>/g,'') || 'Unavailable';
  let selected = variants.find(variant => String(variant.id) === String(new URLSearchParams(location.search).get('variant') || product.selectedId)) || variants.find(variant => variant.available) || variants[0];
  const preferredFramed = variants.find(variant => finishOf(variant) === 'black' && sizeOf(variant) === 'A4' && variant.available) || variants.find(variant => frames.includes(finishOf(variant)) && variant.available);
  if (!new URLSearchParams(location.search).has('variant') && preferredFramed) selected = preferredFramed;
  if (!selected) return;
  let finish = finishOf(selected), size = sizeOf(selected);
  let preferredFrame = frames.includes(finish) ? finish : frames.find(key => variants.some(variant => finishOf(variant) === key && variant.available));
  let artwork = '', ready = false, generating = false, adding = false, uncertain = false, rendering = false;
  let portraitSeen = false, reframing = false;
  let photoRevision = 0, previewRevision = 0, pendingSignature = '', generationSignature = '', pendingRender = false;
  let synchronising = false, returnFocus = null;
  let displayRevision = 0, displayKey = '', displayUrl = '', displayWork = null;
  const api = () => window.BellissimaRoyalPawtraits;
  const royalState = () => api()?.state?.() || {};
  const customMode = () => royalState().custom === true || royalState().slug === 'custom-famous-person';
  const customMissing = () => customMode() && !String(royalState().customPerson || '').trim();
  const artworkInput = () => form.querySelector('input[name="properties[Portrait URL]"]');
  const engine = () => composer.ukPortraitEngine;
  const designSignature = (state = royalState()) => {
    return JSON.stringify([state.slug || '',state.petName || '',Boolean(state.goldFrame),state.customPerson || '',state.species === 'cat' ? 'cat' : 'dog']);
  };
  const sourceSignature = () => designSignature() + ':' + photoRevision;
  let lastDesignSignature = designSignature();
  const progress = composer.querySelector('.gemini-transformer__modal');
  if (progress) root.append(progress);
  const famous = composer.querySelector('.gemini-transformer__famous');
  if (famous) famous.closest('label').hidden = true;
  const uploadLabel = composer.querySelector('.gemini-transformer__label--upload');
  if (uploadLabel) {
    [...uploadLabel.childNodes].filter(node => node.nodeType === 3).forEach(node => node.remove());
    const label = document.createElement('strong'); label.textContent = 'Upload your pet’s photo'; uploadLabel.prepend(label);
    file.setAttribute('aria-label','Upload your pet’s photo');
  }
  function syncFields() {
    const state = royalState();
    const custom = state.custom === true || state.slug === 'custom-famous-person';
    if (document.activeElement !== nameInput) nameInput.value = state.petName || '';
    if (customField) customField.hidden = !custom;
    if (customInput) {
      customInput.maxLength = 100; customInput.required = custom;
      if (document.activeElement !== customInput) customInput.value = state.customPerson || '';
      customInput.setCustomValidity(custom && !String(state.customPerson || '').trim() ? 'Enter the famous person you’d like.' : '');
      customInput.setAttribute('aria-invalid',String(custom && customTouched && !String(state.customPerson || '').trim()));
    }
    if (customError) { customError.textContent = custom && customTouched && !String(state.customPerson || '').trim() ? 'Enter the famous person you’d like.' : ''; customError.hidden = !customError.textContent; }
    $('[data-royal-sheet-title]').textContent = state.name || 'Your Royal Pawtrait';
    section.querySelectorAll('[data-royal-sheet-gold-value]').forEach(button => button.setAttribute('aria-pressed',String((button.dataset.royalSheetGoldValue === 'true') === Boolean(state.goldFrame))));
    const sample = $('[data-royal-sample-layer]');
    sample.dataset.royalGold = String(Boolean(state.goldFrame));
    $('[data-royal-sheet-plaque]').textContent = [state.prefix,state.petName || 'Your Pet'].filter(Boolean).join(' ');
    const customPending = custom && !artwork;
    image.hidden = customPending; sample.hidden = true;
    if (customPlaceholder) customPlaceholder.hidden = !customPending;
    stage.dataset.royalCustomPending = String(customPending);
    if (!artwork) $('[data-royal-preview-note]').textContent = custom ? 'Your custom portrait will appear after you upload your pet’s photo and create your preview.' : 'Portrait example — upload your pet’s photo to create your portrait.';
    if (customPending) cancelDisplayPreview();
    if (dialog.open && !artwork && !customPending && state.image) {
      image.alt = `Example ${state.species === 'cat' ? 'cat' : 'dog'} portrait as ${state.name}`;
      prepareDisplayPreview(state.image, state).catch(() => {});
    }
  }

  function displayRatio() {
    const printRatio = size === '30X40' ? 3 / 4 : 21 / 29.7;
    return finish === 'canvas' ? printRatio * 1.033784 : printRatio;
  }
  function cancelDisplayPreview() {
    displayRevision++; displayWork = null; displayKey = '';
    stage.dataset.royalPreviewPending = 'true';
  }
  function previewImage(source) {
    return bounded(new Promise((resolve,reject) => {
      const sourceImage = new Image(); sourceImage.crossOrigin = 'anonymous';
      sourceImage.onload = () => sourceImage.naturalWidth ? resolve(sourceImage) : reject(new Error('The portrait image could not be read.'));
      sourceImage.onerror = () => reject(new Error('The portrait image could not load.'));
      sourceImage.src = source;
    }));
  }
  function fitDisplayArtwork(source, ratio, edgeToEdge) {
    const sourceWidth = source.naturalWidth || source.width, sourceHeight = source.naturalHeight || source.height;
    const fitted = document.createElement('canvas');
    fitted.height = sourceHeight; fitted.width = Math.max(1,Math.round(sourceHeight * ratio));
    const context = fitted.getContext('2d');
    if (!context) throw new Error('The portrait preview could not be prepared.');
    context.fillStyle = '#2c201a'; context.fillRect(0,0,fitted.width,fitted.height);
    if (edgeToEdge) {
      // Normalize only the sub-pixel A-series rounding difference; keep the whole gold rail and plaque.
      context.drawImage(source,0,0,sourceWidth,sourceHeight,0,0,fitted.width,fitted.height);
      return fitted;
    }
    const scale = Math.min(fitted.width / sourceWidth,fitted.height / sourceHeight,1);
    const width = sourceWidth * scale, height = sourceHeight * scale;
    context.imageSmoothingEnabled = true; context.imageSmoothingQuality = 'high';
    context.drawImage(source,(fitted.width - width) / 2,(fitted.height - height) / 2,width,height);
    return fitted;
  }
  function previewBlob(canvas) {
    return bounded(new Promise((resolve,reject) => {
      canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('The portrait preview could not be prepared.')),'image/png');
    }));
  }
  function prepareDisplayPreview(source, sampleState) {
    const ratio = displayRatio();
    const edgeToEdge = finish !== 'canvas' && (sampleState || engine()?.royalState?.())?.goldFrame === true;
    const key = JSON.stringify([source,ratio,edgeToEdge,sampleState ? [sampleState.slug,sampleState.petName,sampleState.prefix,sampleState.goldFrame,sampleState.species] : null]);
    if (key === displayKey && displayUrl && image.getAttribute('src') === displayUrl) {
      if (displayWork && displayWork.key !== key) { displayRevision++; displayWork = null; }
      stage.dataset.royalPreviewPending = 'false';
      return Promise.resolve(true);
    }
    if (displayWork?.key === key) return displayWork.promise;
    const revision = ++displayRevision;
    stage.dataset.royalPreviewPending = 'true';
    const current = () => revision === displayRevision && ratio === displayRatio() && edgeToEdge === (finish !== 'canvas' && (sampleState || engine()?.royalState?.())?.goldFrame === true) && (!sampleState || !artwork && !customMode());
    const promise = previewImage(source).then(sourceImage => {
      if (!current()) return null;
      if (sampleState) {
        if (typeof api()?.composePreview !== 'function') throw new Error('The portrait example could not be prepared.');
        return api().composePreview(sourceImage,sampleState);
      }
      return sourceImage;
    }).then(master => {
      if (!master || !current()) return null;
      if (edgeToEdge) {
        if (typeof api()?.cropPrintPreview !== 'function') throw new Error('The print preview could not be prepared.');
        master = api().cropPrintPreview(master);
      }
      return previewBlob(fitDisplayArtwork(master,ratio,edgeToEdge));
    }).then(blob => {
      if (!blob || !current()) return false;
      const nextUrl = URL.createObjectURL(blob), previousUrl = displayUrl;
      displayUrl = nextUrl; displayKey = key;
      image.src = nextUrl; stage.dataset.royalPreviewPending = 'false';
      if (previousUrl) URL.revokeObjectURL(previousUrl);
      return true;
    }).catch(error => {
      if (!current()) return false;
      if (sampleState) $('[data-royal-preview-note]').textContent = 'This portrait example could not load. Please choose another portrait.';
      throw error;
    }).finally(() => { if (displayWork?.revision === revision) displayWork = null; });
    displayWork = {key,revision,promise};
    return promise;
  }
  window.addEventListener('pagehide',() => { if (displayUrl) URL.revokeObjectURL(displayUrl); });
  function syncNative() {
    selected.options.forEach((value,index) => {
      const control = form.querySelector(`select[data-index="option${index + 1}"]`);
      if (control) control.value = value;
    });
    master.value = String(selected.id);
    form.querySelector('select[data-index="option1"]')?.dispatchEvent(new Event('change',{bubbles:true}));
    master.dispatchEvent(new Event('change',{bubbles:true}));
  }
  function chooseVariant(nextFinish,nextSize) {
    const matches = variants.filter(variant => finishOf(variant) === nextFinish);
    return matches.find(variant => sizeOf(variant) === nextSize && variant.available) || matches.find(variant => variant.available) || matches[0];
  }
  function selectVariant(variant) {
    if (!variant || adding || reframing) return;
    selected = variant; finish = finishOf(variant); size = sizeOf(variant);
    if (frames.includes(finish)) preferredFrame = finish;
    syncNative(); renderOptions();
    if (artwork && !generating) presentArtwork('variant-change');
    else if (!artwork) syncFields();
  }
  function button(label,active,disabled,click) {
    const element = document.createElement('button'); element.type = 'button'; element.className = 'royal-sheet__choice';
    element.setAttribute('aria-pressed',String(active)); element.disabled = Boolean(disabled || adding || reframing);
    const title = document.createElement('strong'); title.textContent = label; element.append(title); element.addEventListener('click',click); return element;
  }
  function renderOptions() {
    const finishMount = $('[data-royal-finishes]'); finishMount.replaceChildren();
    [{key:'none',label:'Print'},{key:'canvas',label:'Canvas'},{key:'framed',label:'Framed'}].forEach(({key,label}) => {
      const matching = variants.filter(variant => familyOf(finishOf(variant)) === key);
      if (!matching.length) return;
      const element = button(label,key === familyOf(finish),!matching.some(variant => variant.available),() => selectVariant(chooseVariant(key === 'framed' ? preferredFrame : key,size)));
      const available = matching.filter(variant => variant.available);
      const cheapest = (available.length ? available : matching).reduce((a,b) => a.price < b.price ? a : b);
      const from = document.createElement('span'); from.textContent = 'From ' + money(cheapest); element.append(from); finishMount.append(element);
    });
    const frameMount = $('[data-royal-frames]'); frameMount.replaceChildren(); $('[data-royal-frame-fieldset]').hidden = familyOf(finish) !== 'framed';
    frames.forEach(key => {
      const matching = variants.filter(variant => finishOf(variant) === key);
      if (!matching.length) return;
      const element = button(names[key],key === finish,!matching.some(variant => variant.available),() => selectVariant(chooseVariant(key,size)));
      const swatch = document.createElement('span'); swatch.className = 'royal-sheet__swatch'; swatch.dataset.colour = key; swatch.setAttribute('aria-hidden','true'); element.prepend(swatch); frameMount.append(element);
    });
    const sizeMount = $('[data-royal-sizes]'); sizeMount.replaceChildren();
    [...new Set(variants.filter(variant => finishOf(variant) === finish).map(sizeOf))].forEach(key => {
      const matching = variants.filter(variant => finishOf(variant) === finish && sizeOf(variant) === key);
      const variant = matching.find(item => item.available) || matching[0];
      const element = button(sizes[key] || key,key === size,!variant?.available,() => selectVariant(variant));
      const dimension = document.createElement('span'); dimension.textContent = key === '30X40' ? dimensions[key] : dimensions[key] ? `${key} · ${dimensions[key]}` : variant.options[0];
      const price = document.createElement('span'); price.textContent = money(variant); element.append(dimension,price);
      if (sizes[key] === 'Large' && variant?.available) { const badge = document.createElement('small'); badge.className = 'royal-sheet__popular'; badge.textContent = 'Most popular'; element.append(badge); }
      sizeMount.append(element);
    });
    const inclusions = finish === 'canvas' ? ['Premium canvas','Solid 2 cm wooden frame','Hanging kit included'] : finish === 'none' ? ['Premium art print'] : ['Premium art print','Beautifully framed','Ready to hang'];
    $('[data-royal-inclusions]').replaceChildren(...inclusions.map(text => { const item = document.createElement('li'); item.textContent = text; return item; }));
    $('[data-royal-summary]').textContent = `${names[finish]} · ${sizes[size] || size}`;
    $('[data-royal-price]').textContent = money(selected);
    stage.dataset.finish = finish;
    const ratio = size === '30X40' ? '3 / 4' : '21 / 29.7';
    stage.style.setProperty('--pop-canvas-ratio',ratio); stage.style.setProperty('--pop-portrait-ratio',ratio);
    syncAction();
  }
  function syncAction() {
    section.querySelectorAll('[data-royal-after-preview]').forEach(element => { element.hidden = !portraitSeen; });
    const canOrder = ready && !customMissing() && !generating && !rendering && !reframing && !adding && !uncertain && selected.available && artworkInput()?.value === artwork && generationSignature === sourceSignature();
    nativeAdd.disabled = !canOrder;
    cta.textContent = adding ? 'Adding to basket…' : generating ? 'Creating your portrait…' : reframing ? 'Updating gold frame…' : rendering || pendingRender ? 'Preparing your preview…' : ready ? `Add to basket · ${money(selected)}` : artwork ? 'Show my preview' : 'Create my preview';
    cta.disabled = adding || generating || rendering || reframing || pendingRender || uncertain || customMissing() || (ready ? !canOrder : !artwork && (generate.disabled || !file.files?.length));
    nameInput.disabled = generating || rendering || reframing || adding;
    if (customInput) customInput.disabled = !customMode() || generating || rendering || reframing || adding;
    file.disabled = generating || rendering || reframing || adding;
    section.querySelectorAll('[data-royal-sheet-gold-value]').forEach(control => { control.disabled = generating || rendering || reframing || adding; });
  }
  function invalidate() {
    portraitSeen = false;
    previewRevision++; artwork = ''; ready = false; pendingRender = false; rendering = false; generationSignature = ''; uncertain = false;
    root.dataset.view = 'upload'; composer.classList.remove('gemini-transformer--hidden'); composer.removeAttribute('aria-hidden');
    $('[data-royal-preview-note]').textContent = 'Portrait example — create a new preview to see your changes.';
    $('[data-royal-basket-link]').hidden = true; status.textContent = ''; syncFields(); syncAction();
    if (!generating && progress?.classList.contains('is-open')) root.dispatchEvent(new CustomEvent('uk:portrait-presented',{bubbles:true,detail:{source:'invalidated'}}));
  }
  function openSheet() {
    if (!dialog.open) { returnFocus = document.activeElement; dialog.showModal(); document.documentElement.classList.add('royal-sheet-open'); }
    syncFields(); renderOptions();
    if (artwork && !reframing && (pendingRender || !ready)) presentArtwork('reopened');
    else if (customMode() && !artwork && !generating) customInput?.focus();
  }
  function closeSheet() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close',() => { document.documentElement.classList.remove('royal-sheet-open'); returnFocus?.focus?.({preventScroll:true}); });
  $('[data-royal-sheet-close]').addEventListener('click',closeSheet);
  dialog.addEventListener('click',event => { if (event.target === dialog) closeSheet(); });
  document.addEventListener('royal-pawtraits:open',openSheet);
  document.addEventListener('royal-pawtraits:change',() => {
    if (synchronising) return;
    const signature = designSignature();
    if (signature !== lastDesignSignature) {
      const previousSignature = lastDesignSignature, previous = engine()?.royalState?.();
      lastDesignSignature = signature;
      const goldOnly = artwork && portraitSeen && previous && !generating && !adding && !reframing &&
        generationSignature === previousSignature + ':' + photoRevision &&
        designSignature({...royalState(),goldFrame:previous.goldFrame}) === previousSignature;
      if (goldOnly) updateGoldFrame(previous);
      else invalidate();
    }
    else syncFields();
  });
  nameInput.addEventListener('input',() => { if (!generating && !adding) api()?.set?.({petName:nameInput.value}); });
  customInput?.addEventListener('input',() => {
    if (generating || rendering || adding) return;
    customTouched = true; api()?.set?.({customPerson:customInput.value}); syncFields(); syncAction();
  });
  customInput?.addEventListener('blur',() => { customTouched = true; syncFields(); syncAction(); });
  section.querySelectorAll('[data-royal-sheet-gold-value]').forEach(control => control.addEventListener('click',() => { if (!generating && !adding) api()?.set?.({goldFrame:control.dataset.royalSheetGoldValue === 'true'}); }));
  file.addEventListener('change',() => { if (!generating && !adding) { photoRevision++; invalidate(); } });
  async function updateGoldFrame(previous) {
    const previousArtwork = artwork, capturedSignature = sourceSignature();
    const next = {...previous,goldFrame:Boolean(royalState().goldFrame)};
    reframing = true; ready = false; status.textContent = '';
    api()?.lock?.(true); syncFields(); renderOptions();
    try {
      if (typeof api()?.reframe !== 'function') throw new Error('The gold frame could not be updated. Please try again.');
      const result = await api().reframe(previousArtwork,next);
      if (sourceSignature() !== capturedSignature || artwork !== previousArtwork || artworkInput()?.value !== previousArtwork) throw new Error('Your portrait options changed. Please review your portrait.');
      await engine().applyArtwork({url:result.hostedUrl,royalPawtraits:next},'gold-frame-change');
    } catch (error) {
      api()?.lock?.(false);
      synchronising = true;
      try { api()?.set?.({goldFrame:previous.goldFrame}); } finally { synchronising = false; }
      api()?.lock?.(true);
      lastDesignSignature = designSignature();
      if (artworkInput()?.value !== previousArtwork) {
        try { await engine().applyArtwork({url:previousArtwork,royalPawtraits:previous},'gold-frame-change'); }
        catch (_) { ready = false; }
      } else {
        artwork = previousArtwork; generationSignature = sourceSignature();
        await presentArtwork('gold-frame-restored');
      }
      status.textContent = error.message || 'The gold frame could not be updated. Your previous portrait has been kept.';
    } finally {
      reframing = false; api()?.lock?.(false); syncFields(); renderOptions();
    }
  }
  function bounded(work,milliseconds = 15000) {
    let timer; return Promise.race([work,new Promise((_,reject) => { timer = setTimeout(() => reject(new Error('The portrait preview could not finish loading.')),milliseconds); })]).finally(() => clearTimeout(timer));
  }
  async function settlePreview() {
    await bounded(image.decode ? image.decode() : new Promise((resolve,reject) => {
      if (image.complete) { image.naturalWidth ? resolve() : reject(new Error('The portrait image could not load.')); return; }
      image.addEventListener('load',resolve,{once:true}); image.addEventListener('error',reject,{once:true});
    }));
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    if (!dialog.open) return false;
    if (finish === 'none') return true;
    let observer, resize, close;
    try {
      return await bounded(new Promise(resolve => {
        const check = () => { if (dialog.open && stage.clientWidth > 0 && stage.clientHeight > 0 && stage.classList.contains('pop-canvas-rendered')) resolve(true); };
        close = () => resolve(false); dialog.addEventListener('close',close,{once:true});
        observer = new MutationObserver(check); observer.observe(stage,{attributes:true,attributeFilter:['class','style']});
        resize = new ResizeObserver(check); resize.observe(stage); check();
      }));
    } finally { observer?.disconnect(); resize?.disconnect(); if (close) dialog.removeEventListener('close',close); }
  }
  async function presentArtwork(source) {
    if (!artwork) return;
    const revision = ++previewRevision;
    ready = false; rendering = dialog.open; pendingRender = !dialog.open; syncAction();
    if (!dialog.open) return;
    if (!portraitSeen) root.scrollTop = 0;
    try {
      if (!await prepareDisplayPreview(artwork)) return;
      const usable = await settlePreview();
      if (revision !== previewRevision) return;
      rendering = false; pendingRender = !usable;
      if (!usable) { syncAction(); return; }
      ready = true; portraitSeen = true; root.dataset.view = 'ready';
      status.textContent = '';
      $('[data-royal-preview-note]').textContent = 'Your personalised portrait';
      syncAction(); root.dispatchEvent(new CustomEvent('uk:portrait-presented',{bubbles:true,detail:{source}}));
    } catch (error) {
      if (revision !== previewRevision) return;
      ready = false; rendering = false; pendingRender = false;
      status.textContent = 'Your portrait is saved, but its preview could not display. Close and reopen this sheet to try again.';
      syncAction(); root.dispatchEvent(new CustomEvent('uk:portrait-presented',{bubbles:true,detail:{source:'display-error'}}));
    }
  }
  function generated(source) {
    if (source !== 'gold-frame-change') portraitSeen = false;
    const raw = artworkInput()?.value || '';
    if (!/^https:\/\/cdn\.shopify\.com\/s\/files\/1\/0284\/5284\/7688\/files\/(?:gemini|dpc)_[^?#]+(?:\?[^#]*)?$/.test(raw)) { status.textContent = 'The generated portrait could not be verified. Please try again.'; generating = false; syncAction(); return; }
    const saved = engine()?.royalState?.();
    synchronising = true;
    try {
      if (saved) {
        api()?.set?.({slug:saved.slug,petName:saved.petName,goldFrame:saved.goldFrame,species:saved.species === 'cat' ? 'cat' : 'dog',exampleMode:['mixed','dog','cat'].includes(saved.exampleMode) ? saved.exampleMode : saved.species === 'cat' ? 'cat' : 'dog',...((saved.custom === true || saved.slug === 'custom-famous-person') && typeof saved.customPerson === 'string' ? {customPerson:saved.customPerson} : {})});
      }
    } finally { synchronising = false; }
    if (saved && royalState().slug !== saved.slug) {
      generating = false; pendingSignature = '';
      const storedArtwork = artworkInput();
      if (storedArtwork) storedArtwork.value = '';
      engine()?.setRoyalProperties?.({});
      invalidate();
      lastDesignSignature = designSignature();
      status.textContent = 'That portrait design is no longer available. Please choose another.';
      if (!dialog.open && ['saved-entry','saved-selection','emailed-entry'].includes(source)) openSheet();
      return;
    }
    lastDesignSignature = designSignature();
    cancelDisplayPreview();
    generating = false; artwork = raw; generationSignature = source === 'generated' ? pendingSignature : sourceSignature();
    composer.classList.remove('gemini-transformer--hidden'); composer.removeAttribute('aria-hidden');
    image.alt = 'Your personalised Royal Pawtrait'; syncFields(); renderOptions();
    if (!dialog.open && ['saved-entry','saved-selection','emailed-entry'].includes(source)) openSheet();
    presentArtwork(source);
  }
  root.addEventListener('uk:portrait-progress-open',() => {
    generating = true; ready = false; portraitSeen = false; pendingSignature = sourceSignature(); status.textContent = ''; syncAction();
  });
  root.addEventListener('uk:portrait-ready',event => generated(event.detail?.source || 'generated'));
  root.addEventListener('uk:portrait-restore-error',() => { generating = false; ready = false; portraitSeen = false; syncAction(); openSheet(); });
  new MutationObserver(() => {
    if (generating && !generate.disabled) { generating = false; syncAction(); }
    else if (!generating) syncAction();
  }).observe(generate,{attributes:true,attributeFilter:['disabled']});
  if (sourceStatus) new MutationObserver(() => { if (sourceStatus.classList.contains('gemini-transformer__status--error') && !generating) syncAction(); }).observe(sourceStatus,{attributes:true,childList:true,subtree:true});
  cta.addEventListener('click',() => {
    if (customMissing()) { customTouched = true; syncFields(); syncAction(); customInput?.focus(); return; }
    if (cta.disabled) return;
    if (ready) form.requestSubmit(nativeAdd);
    else if (artwork) presentArtwork('retry-display');
    else { status.textContent = ''; generate.click(); }
  });
  form.addEventListener('submit',async event => {
    event.preventDefault();
    if (nativeAdd.disabled || customMissing() || adding || !ready || artworkInput()?.value !== artwork || generationSignature !== sourceSignature()) return;
    const id = String(selected.id), properties = {};
    form.querySelectorAll('input[name^="properties["]').forEach(input => { const match = /^properties\[(.+)\]$/.exec(input.name); if (match && !input.disabled && input.value) properties[match[1]] = input.value; });
    if (properties['Portrait URL'] !== artwork || master.value !== id) return;
    const canonicalArtwork = artwork, capturedSignature = sourceSignature(), capturedState = engine()?.royalState?.();
    let basketRequested = false;
    adding = true; status.textContent = ''; renderOptions();
    try {
      if (!canvas(selected) && capturedState?.goldFrame === true) {
        if (typeof api()?.preparePrintArtwork !== 'function') throw new Error('Your print could not be prepared. Please try again.');
        properties['Portrait URL'] = await api().preparePrintArtwork(canonicalArtwork,capturedState);
      }
      if (artwork !== canonicalArtwork || artworkInput()?.value !== canonicalArtwork || sourceSignature() !== capturedSignature || generationSignature !== capturedSignature || String(selected.id) !== id || master.value !== id) throw new Error('Your portrait options changed. Please review your portrait before adding it.');
      basketRequested = true;
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1,properties}]})});
      const data = await response.json().catch(() => ({}));
      if (!response.ok) { const error = new Error(data.description || data.message || 'This portrait could not be added to your basket.'); error.confirmed = true; throw error; }
      const added = data.items?.[0] || data;
      if (String(added.variant_id || added.id) !== id) throw new Error('We could not confirm which portrait was added.');
      status.textContent = 'Added to your basket.'; location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (error) {
      if (!basketRequested) error.confirmed = true;
      if (!error.confirmed) { uncertain = true; status.textContent = 'We could not confirm the basket update. Please check your basket before trying again.'; $('[data-royal-basket-link]').hidden = false; }
      else status.textContent = error.message;
    } finally { adding = false; renderOptions(); }
  });
  root.ukPortraitPresentation = {state:() => ({portrait:artwork,demo:!artwork,variantId:String(selected.id),ready}),selectVariant:id => { const variant = variants.find(item => String(item.id) === String(id)); if (!variant) return false; selectVariant(variant); return true; }};
  section.dataset.controllerReady = 'true';
  syncNative(); syncFields(); renderOptions();
  root.dispatchEvent(new CustomEvent('uk:portrait-ui-initialized',{bubbles:true}));
  if (artworkInput()?.value) generated('saved-entry');
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseRoyalProduct, {once:true});
else initialiseRoyalProduct();
